import { Card, Col, Container, Row, Badge } from "react-bootstrap";
import { cents, showMoney } from "./Data/Money";
import { useLoaderData, useNavigate } from "react-router-dom";
import { PageTitle } from "./Controls/PageTitle";
import { facilityNumberImg } from "./Data/Common";
import { SubListEntry } from "./Data/ApiTypes";
import { pluralize } from "./Data/English";
import { showSubscriptionStatus } from "./Data/Subscription";
import { X } from "react-bootstrap-icons";
import { useHandleNavigation } from "./shared/navigation";

export function PlansPage() {
  const subs = useLoaderData() as SubListEntry[];
  const handleNavigation = useHandleNavigation();

  return (
    <Container fluid>
      <Row>
        <Col>
          <PageTitle>Plans</PageTitle>
          {subs.length === 0 && <>You don't have any parking plans</>}
          {subs.map((sub) => {
            const facility = sub.facility;
            const quantity = sub.quantity;
            const price = sub.price;
            const unitPrice = sub.unitPrice;
            const spots = sub.quantity;

            return (
              <Card
                key={sub.subscriptionId}
                className="my-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleNavigation(
                    `/facility/${sub.facility.facilityId}/parker/${sub.parkerId}/plan/${sub.subscriptionId}`,
                    {
                      from: "plansList",
                      parentParkerId: sub.parkerId,
                    }
                  );
                }}
              >
                <Card.Header className="text-start d-flex align-items-center gap-1">
                  <Badge>{showSubscriptionStatus(sub.status)}</Badge>{" "}
                  {sub.plan.name}
                </Card.Header>
                <Card.Body className="purchase-layout gap-2">
                  <div className="grid-area-a">
                    <img
                      className="facility-result-pic"
                      src={facilityNumberImg(facility.listImageId)}
                      style={{ aspectRatio: "1 / 1", objectFit: "cover" }}
                    />
                  </div>
                  <div className="grid-area-b">
                    <div className="fw-bold">{sub.facility.name}</div>
                    <div className="fw-normal">
                      {spots} {pluralize(quantity, "Spot", "Spots")}
                      <>
                        <X /> {showMoney(cents(unitPrice!))}
                      </>
                    </div>
                  </div>
                  <div
                    className="grid-area-c position-relative"
                    style={{ justifySelf: "end" }}
                  >
                    <div className="fs-4 fw-bold">
                      {price && showMoney(cents(price))}
                    </div>
                    <div
                      style={{
                        fontSize: "0.75em",
                        position: "relative",
                        top: "-5%",
                        left: "0.05em",
                      }}
                      className="text-end"
                    >
                      monthly
                    </div>
                  </div>
                  <div className="grid-area-d text-end d-flex gap-2"></div>
                </Card.Body>
              </Card>
            );
          })}
        </Col>
      </Row>
    </Container>
  );
}
